import './platform/zodConfig.js';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { router } from './app/router.js';
import { queryClient } from './platform/queries.js';
import { restorePersisted } from './platform/persist.js';
import { initPreview, preview } from './platform/preview.js';
import { registerServiceWorker } from './platform/pwa.js';
import './index.css';

// P21: Vorschau „Als Gast ansehen“ – dann nichts aus dem Zwischenspeicher der Leitung zeigen
initPreview();
// Zuletzt Gesehenes einlesen, bevor gezeichnet wird – auch ohne Netz steht die App sofort da (P10)
void (preview() ? Promise.resolve() : restorePersisted())
  .catch(() => {})
  .finally(() => {
    createRoot(document.getElementById('root')!).render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </StrictMode>,
    );
  });
registerServiceWorker();
